import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  getActiveKnowledgeBaseId,
  setActiveKnowledgeBaseId,
} from "@/lib/knowledgeBaseRegistry";
import { pinKnowledgeBaseActiveSelection } from "@/lib/knowledgeActiveSelection";
import { useKnowledgeBases } from "@/pages/knowledge/useKnowledgeBases";

/** When the URL includes `/knowledge/bases/:baseId`, keep the active base aligned. */
export function useKnowledgeRouteBase(): string {
  const { baseId: routeBaseId } = useParams<{ baseId?: string }>();
  const { orgId, activeId, bases } = useKnowledgeBases();

  useEffect(() => {
    const fromRoute = (routeBaseId || "").trim();
    if (!fromRoute || !orgId) return;
    if (!bases.some((base) => base.id === fromRoute)) return;
    if (fromRoute === activeId) return;
    pinKnowledgeBaseActiveSelection(orgId, fromRoute);
    setActiveKnowledgeBaseId(orgId, fromRoute);
  }, [routeBaseId, orgId, bases, activeId]);

  const fromRoute = (routeBaseId || "").trim();
  if (fromRoute && bases.some((base) => base.id === fromRoute)) return fromRoute;
  if (activeId) return activeId;
  return orgId ? getActiveKnowledgeBaseId(orgId) : "";
}
